import { IActionContext } from '../helpers/ActionContext';
import { ISubscriptionInfo } from '../models/ISubscriptionInfo';
import { Module } from '../Module';
import { Subscriptions } from '../resources/Subscriptions';
import { IResult } from '../ServerApi/types/IResponse';
import { SubscriptionDataConditionType } from '../ServerApi/types/SubscriptionDataCondition';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { ToasterService, ToastType } from './ToasterService';

export interface IChangeSubscriptionDataConditionDialogScope extends ng.IScope {
  checkbox: {
    description: string;
    value: boolean;
  };
}

export class ChangeSubscriptionDataConditionAction {

  public static $inject = ['ConfirmActionDialog', '$translate', 'Subscriptions'];

  constructor(
    private ConfirmActionDialog: ConfirmActionDialog,
    private $translate: ng.translate.ITranslateService,
    private Subscriptions: Subscriptions) { }

  public changeDataCondition(subscription: ISubscriptionInfo, context: IActionContext): ng.IPromise<IResult> {
    const scope = <IChangeSubscriptionDataConditionDialogScope> context.scope.$new();
    const initialValue: boolean = subscription.dataConditionPresent;

    scope.checkbox = {
      description: this.$translate.instant('confirmChangeSubscriptionDataConditionDescription'),
      value: initialValue
    };

    return this.ConfirmActionDialog.open({
      title: this.$translate.instant('confirmChangeSubscriptionDataCondition_Title'),
      bodyTemplateUrl: 'confirmActionDialogInputCheckbox.html',
      scope: scope,
      confirmDisabled: () => scope.checkbox.value === initialValue,
      actionName: this.$translate.instant('confirmChangeSubscriptionDataCondition'),
      action: (dialogInstance: IConfirmActionDialogInstance) => {
        // future optimization: story 554477:We don't need to send requests to server when the user hasn't updated any fields
        const newDataConditionValue: SubscriptionDataConditionType =
              scope.checkbox.value ? 'DataPresent' : 'Always';

        return this.Subscriptions.changeDataCondition([subscription.id], newDataConditionValue).then((result: IResult) => {
          if (result.errors && result.errors.length) {
            dialogInstance.showErrorMessage(
              this.$translate.instant('changeSubscriptionDataConditionFailure'));
          } else {
            ToasterService.instance.pop({
              type: ToastType.Info,
              text: this.$translate.instant('changeSubscriptionDataConditionSuccess')
            });
            subscription.dataConditionPresent = scope.checkbox.value;
          }
          return result;
        });
      }
    }).result.finally(() => {
      scope.$destroy();
    });
  }

}

Module.instance().service('ChangeSubscriptionDataConditionAction', ChangeSubscriptionDataConditionAction);
